export const frPrelProfessionalStatusEntries = [
  ['tns', { label: 'Travailleur non salarié' }],
  ['mandataire_social', { label: 'Mandataire social' }],
  ['gerant_majoritaire', { label: 'Gerant majoritaire' }],
  ['conjoint_collaborateur', { label: 'Conjoint collaborateur' }],
  ['artisan', { label: 'Artisan' }],
  ['profession_liberale', { label: 'Profession libérale' }],
  ['commercant', { label: 'Commerçant' }],
  ['auto_entrepreneur', { label: 'Auto-entrepreneur, entrepreneur individuel' }],
] as const

export type FrPrelProfessionalStatus = (typeof frPrelProfessionalStatusEntries)[number][0]

export const frPrelMandatorySupplementaryEntries = [
  ['SSI', { label: 'SSI (Artisans, Commerçants...)' }],
  ['CIPAV', { label: 'CIPAV (Architectes, Consultants...)' }],
  ['CARMF', { label: 'CARMF (Médecins)' }],
  ['CARCDSF', { label: 'CARCDSF (Dentistes, Sages-femmes)' }],
  ['CARPIMKO', { label: 'CARPIMKO (Infirmiers, kinés...)' }],
  ['CARPV', { label: 'CARPV (Vétérinaires)' }],
  ['CAVEC', { label: 'CAVEC (Experts-comptables...)' }],
  ['CAVAMAC', { label: 'CAVAMAC (Agents d’assurance)' }],
  ['CAVP', { label: 'CAVP (Pharmaciens)' }],
  ['CPRN', { label: 'CPRN (Notaires)' }],
  ['CRN', { label: 'CRN (Huissiers de justice...)' }],
  ['CNBF', { label: 'CNBF (Avocats)' }],
  ['MSA', { label: 'MSA (Activités agricoles...)' }],
  ['ENIM', { label: 'ENIM (Marins)' }],
  ['CAVIMAC', { label: 'CAVIMAC (Ministres du culte...)' }],
] as const

export type FrPrelMandatorySupplementary = (typeof frPrelMandatorySupplementaryEntries)[number][0]

export type MadelinFiscaliteLabel = 'Madelin' | 'Non Madelin' | 'Hors Madelin'
